import React, { useState } from 'react'
import { API_URL } from '../../Config';


function Register() {
    const [name, setName] = useState('');
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [type, setType] = useState('');
    const [error, setError] = useState('');

    const handleSubmit = async (e) => {
        e.preventDefault();
        try {
          const response = await fetch(`${API_URL}/register`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ name, email, password, type }),
          });
          if (!response.ok) {
            const data = await response.json();
            throw new Error(data.message);
          }
          setName('');
          setEmail('');
          setPassword('');
          setType('');
          setError('');
          document.getElementById("success-message").innerHTML = 'User registered successfully';
        } catch (err) {
          setError(err.message);
        }
      };
          
  return (
    <div>
      <div className="register-form">
      <form onSubmit={handleSubmit}>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="Name" />
          <input type="text" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="Email" />
          <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} placeholder="Password" />
          <select value={type} onChange={(e) => setType(e.target.value)}>
            <option value="" disabled defaultValue>--Admin/employee--</option>
            <option value="0">Admin</option>
            <option value="1">Employee</option>
          </select>
          <button type="submit">Submit</button>
        </form>
        {error && <p>{error}</p>}
        <p id="success-message"></p> 
        </div>
    </div>
  )
}

export default Register
